// extracted by mini-css-extract-plugin
module.exports = {"groupCard":"styles_groupCard__2joln"};